import { TOGGLE_DRAWER_FINANC, WAS_IN_FINANCE } from './types';

export const toggleDrawerFinanciamiento = () => dispatch => {
  dispatch({ type: TOGGLE_DRAWER_FINANC });
};

export const setWasInFinance = wasInFinance => dispatch => {
  dispatch({ type: WAS_IN_FINANCE, payload: wasInFinance });
};
